module.exports = __webpack_public_path__ + "static/media/banner.f3307896.png";